<template>
  <v-container>
    <v-row>
      <v-col cols="8" offset="2">
        <v-row>
          <v-col align="center">
            <PageTitle :title="label('title')"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center">
            {{label("description1")}}<br/>
            {{label("description2")}}<br/>
            {{label("description3")}}<br/>
            {{label("description4")}}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-divider/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-form ref="form">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    {{label("reasonDescription")}}
                    <RadioField
                            v-model="data.reason"
                            :name="label('reason')"
                            :items="reasons"
                            required
                            :other=99
                            :other-name="label('reasonOther')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-divider/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    {{label("improvement")}}
                    <TextArea
                            v-model="data.improvements"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-divider/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    {{label("opinion")}}
                    <TextArea
                            v-model="data.opinion"
                    />
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12">
                    <ErrorMessage :message="label('attention')"/>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12">
                    <ErrorMessage :message="errorMessage"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" offset="4">
                    <ActionButton type="delete" @click="submit">
                      {{label("unsubscribe")}}
                    </ActionButton>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PageTitle from "../../atoms/PageTitle";
  import RadioField from "../../atoms/RadioField";
  import TextArea from "../../atoms/TextArea";
  import ActionButton from "../../molecules/ActionButton";
  import {unsubscribeReasons, clientsUnsubscribeReasons} from "../../../enums";
  import ErrorMessage from "../../molecules/ErrorMessage";
  import ComponentMixin from "../../ComponentMixin";
  import {mapActions, mapGetters} from "vuex";
  import ApiMixin from "../../../ApiMixin";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "page",
    name: "UnsubscribePage",
    isRequiredLogin: true,
    data () {
      return {
        data: {},
        errorMessage: null
      }
    },
    computed: {
      ...mapGetters("user", ["user"]),
      reasons () {
        if ( this.isClient ) {
          return clientsUnsubscribeReasons.ja
        }
        return unsubscribeReasons.ja
      },
      isClient () {
        return this.$route.path.includes('/clients/unsubscribe')
      },
    },
    methods: {
      ...mapActions("user", ["unsubscribe"]),
      submit (e, guard) {
        if (this.$refs.form.validate()) {
          guard((release) => {
            this.deleteUser(this.user.id, this.data).then(() => {
              if(this.isClient){
                this.$router.push("/clients/unsubscribe-completed");
              } else {
                this.$router.push("/unsubscribe-completed");
              }
            }).catch( () => {
              this.errorMessage = this.label("failedUnsubscribe");
            }).finally(release);
          }, false)
        }
      }
    },
    components: {
      PageTitle,
      RadioField,
      TextArea,
      ErrorMessage,
      ActionButton
    }
  }
</script>

<style scoped>

</style>
